import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReservationStatus } from "./reservation-status";
import { BookingSummary } from "./booking-summary";
import { RRMessage } from "./rr-message";
import { ShareReservation } from "./share-reservation";
import styled from "styled-components";
import { moduleSettings } from "../../../stores/module-settings.store";
import { bookingStore } from "../../../stores/booking.store";
import { BookingState } from "../../../types";
import { getTagManagerService } from "../../../services/tag-manager.service";
import ReactPixel from "react-facebook-pixel";
import { Loader } from "../../loader/loader";
import { InformationText } from "../../information-text/information-text";

const ValidationWrapper = styled.div`
  margin-bottom: 50px;
`;

const Validation = () => {
  const { t } = useTranslation();
  const booking = bookingStore.booking;
  const canSharingFriend =
    moduleSettings.settings.show_sharing_friend_on_module &&
    booking.booking_state === BookingState.validated;
  const shoudDiplayRRMessage =
    booking.rr_data?.title && booking.booking_state === BookingState.validated;
  const isFrPlt = moduleSettings.isFrPlt;

  useEffect(() => {
    getTagManagerService()?.pushTags("sharing", {
      booking_id: booking.id.toString(),
    });
    ReactPixel.pageView();
  }, []);

  if (moduleSettings.redirectionLink) {
    window.location.replace(moduleSettings.redirectionLink);
  }

  if (window.Cypress) {
    window.__urlToUpdateFromEmail__ = `/instabook/bookings/${booking.id}/update_from_email/?booking_token=${booking.booking_token}`;
  }

  const content = (
    <ValidationWrapper data-test="validation">
      <BookingSummary
        civility={booking.civility}
        firstname={booking.firstname}
        lastname={booking.lastname}
        booked_persons_number={booking.booked_persons_number}
        children_number={booking.children_number}
        time={booking.booking_time}
      />
      <ReservationStatus
        status={booking.booking_state}
        waiting_rank={booking.waiting_rank}
      />
      {canSharingFriend && <ShareReservation />}
      {isFrPlt && (
        <InformationText
          text={t("instabook.bloctel_message")}
          status={"info"}
        />
      )}
      {shoudDiplayRRMessage && <RRMessage />}
    </ValidationWrapper>
  );

  return <>{moduleSettings.redirectionLink ? <Loader /> : content}</>;
};

export const ConfirmationValidation = memo(Validation);
